<!--
	@component

	- Formats text with predefined formats.
	- Applies non-breaking spaces where applicable
	- Accepts both dynamic and static text
	- **Should** be used almost everywhere

	```svelte
	<Formatted text="[https://google.com][[Link to Google]]]" />
	<Formatted text="bold[[Bold text]]" />
	<Formatted text="semibold[[Semibold text]]" />
	<Formatted text="q[[Quoted text]]" />
	```

	Normally, to allow multiline `text` prop, like so
	```svelte
		<Formatted
			text="
				This is very, very long
				text and requires many,
				many lines.
			"
		/>
	```

	without disturbing the HTML tree, whitespaces are stripped from
	both end and start and more whitespaces in a sequence is normalized
	into one.

	To avoid this, for example in use with <pre> tag, you can use `pre`
	prop
	```svelte
		<Formatted
			pre
			text="Roses are red,
	text is wrapped well,
	you better use Zed
	for a fast shell."
		/>
	```
-->
<script lang="ts">
	import { formatify } from "@core/utils/formatify.js";

	export let text: string;
	export let pre = false;

	/* eslint-disable svelte/no-at-html-tags */
</script>

{@html formatify(pre ? text : text.trim().replace(/[\n\s\r]+/gmu, " "))}
